//
// Module for the Benefit Estimate wizard's Overrides step
//
rs.module("participant/benefit/estimates/create/wizard/overridesstep",

    ["controls/data/grid"],

    function (gridModule) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(benefitEstimateKey, jsSelectors, backendUrls, fasGrid, fasPayPeriodsGridLrsApi) {

            var fasContainer = $.js(jsSelectors.fasContainer);
            var fasLoadingSpinner = fasContainer.js(jsSelectors.fasLoadingSpinner);

            // On FAS grid row selection change, update the FAS Pay Periods grid
            fasGrid.selectionChanged(function (values, rows) {
                if (_executeSelectionChanged && values.length > 0) {
                    updateFasPayPeriodsGrid(values[0]);
                }

                _executeSelectionChanged = true;
            });

            // Update the FAS Pay Periods grid
            function updateFasPayPeriodsGrid(estimateFASSummaryKey) {
                fasLoadingSpinner.show();

                gridModule.update(
                    backendUrls.getFasPayPeriodsGridData,
                    {
                        benefitEstimateKey: benefitEstimateKey,
                        estimateFASSummaryKey: estimateFASSummaryKey
                    },
                    fasPayPeriodsGridLrsApi.agGridApi,
                    function done() {
                        fasLoadingSpinner.hide();
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);